import { render, staticRenderFns } from "./EvidencePanel.vue?vue&type=template&id=383f8ac2"
import script from "./EvidencePanel.vue?vue&type=script&lang=ts"
export * from "./EvidencePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports